// getters
export const getAccessToken = () => localStorage.getItem("jwt_access_token");
export const getRefreshToken = () => localStorage.getItem("jwt_refresh_token");

//setters
export const setAccessToken = (token: string) => localStorage.setItem("jwt_access_token", token);
export const setRefreshToken = (token: string) => localStorage.setItem("jwt_refresh_token", token);
